import React, { useEffect, useRef, useState } from "react";
import { OnlineExamPage } from "app-configs/routesConfig";
import { Box } from "styled-components/box";
import { Nav, Tab, Tabs } from "react-bootstrap";
import Result from "containers/onlineExam/Result";
import Plan from "containers/onlineExam/Plan";
import { onlineExamString, stringFiles } from "res/strings";
import { withTranslation } from "i18n";
import { useDispatch, useSelector } from "react-redux";
import { selectCurrentPage, selectIsFetchingExams, selectIsFetchingResults, selectOnlineExamDetailData } from "redux/onlineExam/onlineExam.selectors";
import { createStructuredSelector } from "reselect";
import { postOnlineExamStartAsync, resetPlanOffset, resetResultOffset, setCurrentPage, setOnlineExam } from "redux/onlineExam/onlineExam.actions";
import { CookieUtils } from "utils";
import { useRouter } from "next/router";
import Axios from "axios";
import { DiffrenceDatesInMs } from "utils/Date";

export const TabsType = {
  exams: 0,
  results: 1,
}


const OnlineExam = ({ t }) => {


  const dispatch = useDispatch();
  const router = useRouter();
  const cookieInstance = new CookieUtils();

  const studentID = cookieInstance.getCookie("studentID");
  const semesterID = cookieInstance.getCookie("semesterID");


  const {
    currentPage,
    isFetchingExams,
    isFetchingResults,
    ///
    onlineExamDetailData
  } = useSelector(
    createStructuredSelector({
      currentPage: selectCurrentPage,
      isFetchingExams: selectIsFetchingExams,
      isFetchingResults: selectIsFetchingResults,

      //
      onlineExamDetailData: selectOnlineExamDetailData,


    })
  );


  useEffect(() => {
    if (currentPage !== undefined) {
      checkUnfinishedExams()
    }
  }, [currentPage]);




  const finishExam = () => {
    const answerList = onlineExamDetailData.questionList.map((question) => ({
			id: question.id,
			chooseAnswerId:
				question.answered !== undefined &&
				question.onlineExamQuestionAnswers.length > 0
					? question.answered
					: null,
			answerText: question.answerText,
			formula: question.formulaText,
			attachments: question.attachmentList,
		}));
    const onSuccess = () => {

    };

    const onError = () => {
      dispatch(setOnlineExam(-1))
    };

    dispatch(
      postOnlineExamStartAsync({
        studentID: studentID,
        onlineExamID: onlineExamDetailData.id,
        semesterID: semesterID,
        body: answerList,
        isAutomaticSended: true,
        onSuccess: onSuccess,
        isExpired: true,
        onError: onError
      })
    );

  }

  const checkUnfinishedExams = () => {
    if (onlineExamDetailData) {
      if (onlineExamDetailData.isPostExamAtEndTime && onlineExamDetailData.id && DiffrenceDatesInMs(onlineExamDetailData.endAt) === 0) {
        finishExam()
      }
    }
  }



  return (
    <>

      <Nav activeKey={currentPage || TabsType.exams} variant="tabs" style={{
        height: 'fit-content', top: "3em",
        zIndex: "10"
      }}
        className="w-100 bg-light position-fixed justify-content-center customTab">
        <Nav.Item onClick={() => dispatch(setCurrentPage(TabsType.exams))}>
          <Nav.Link className="customTabItem" eventKey={TabsType.exams}>{t(onlineExamString.planTab)}</Nav.Link>
        </Nav.Item>
        <Nav.Item onClick={() => dispatch(setCurrentPage(TabsType.results))}>
          <Nav.Link className="customTabItem" eventKey={TabsType.results}>{t(onlineExamString.resultTab)}</Nav.Link>
        </Nav.Item>
      </Nav>
      <div style={{ top: "2em", position: "relative" }}>
        <div>
          {currentPage === TabsType.exams ? <Plan checkUnfinishedExams={checkUnfinishedExams} /> : <Result />}
        </div>
      </div>

    </>
  )
};

OnlineExam.config = OnlineExamPage;



export default withTranslation(stringFiles.common)(OnlineExam);
